import { colors } from "colors"
import { Platform, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  ball1: {
    backgroundColor: colors.white,
    borderRadius: 99,
    bottom: -10,
    height: 40,
    left: -15,
    opacity: 0.2,
    position: "absolute",
    width: 40,
    zIndex: -99,
  },
  ball2: {
    backgroundColor: colors.white,
    borderRadius: 99,
    bottom: 16,
    height: 25,
    left: 8,
    opacity: 0.2,
    position: "absolute",
    width: 25,
    zIndex: -99,
  },
  ball3: {
    backgroundColor: colors.white,
    borderRadius: 99,
    height: 110,
    opacity: 0.2,
    position: "absolute",
    right: -22,
    top: -22,
    width: 110,
    zIndex: -99,
  },
  ball4: {
    backgroundColor: colors.white,
    borderRadius: 99,
    height: 55,
    opacity: 0.2,
    position: "absolute",
    right: -22,
    top: 65,
    width: 55,
    zIndex: -99,
  },
  container: { flex: 1, marginHorizontal: 10 },
  headerContentContainer: {
    alignItems: "center",
    flexDirection: "row",
  },
  headerTitle: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 16,
    marginLeft: 10,
  },
  linearGradient: { paddingTop: 20, width: "100%", zIndex: -99999 },
  rightContainer: {
    alignItems: "flex-end",
    flex: 1,
    justifyContent: "center",
  },
})
